import { setGADataLayer } from 'analytics'
import UGE from 'creation/src/components/uge-gl'
import { UGERef } from 'creation/src/components/uge-gl/types'
import { useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Button from 'ui/src/components/controls/button'
import { WEB_API_KEY } from '../../../../../shared/api'
import { UGE_GA_PREFIX } from '../../../constants'
import { CreationToolsContext } from '../../../manager'
import CreationToolOutputType from '../../../types/output-type'
import { validateSourceByOutput } from '../../../utils/validate-source'
import { CreationToolUploadContext } from '../manager'
import Modal from './modal'

const SaveButton = styled(Button)`
    bottom: 0;
    position: sticky;
    margin: 10px auto;
    width: 100%;
    z-index: 2;
`

const GA_CATEGORY = 'Upload'

const CreationUploadEditor = () => {
    const ugeRef = useRef<UGERef>(null)
    const { apiKey, trackEvent } = useContext(CreationToolsContext)
    const { editing, setEditing, updateUploadSource } = useContext(CreationToolUploadContext)
    const [isSaving, setIsSaving] = useState<boolean>(false)

    const fireGAEvent = (action: string, value?: string) => {
        if (!editing) return

        const gaLabel = CreationToolOutputType.title(editing.source.outputType)
        trackEvent(GA_CATEGORY, `${UGE_GA_PREFIX}${action}`, gaLabel, value)
    }

    useEffect(() => {
        if (!editing) return

        fireGAEvent('Edit')
    }, [editing, fireGAEvent])

    if (!editing) {
        return null
    }

    const {
        defaultEditor,
        source: uploadSource,
        source: { edited: editedUploadFile, source: uploadFile },
    } = editing

    function onCancel() {
        setEditing(undefined)
    }

    async function onDone() {
        if (!ugeRef.current) return

        setIsSaving(true)

        const gif = await ugeRef.current.createGIF()

        if (gif) {
            const edited = await validateSourceByOutput(gif, uploadSource.outputType)

            updateUploadSource({
                ...uploadSource,
                edited,
            })
        }

        setEditing(undefined)
        setIsSaving(false)
    }

    return (
        <Modal onCancel={onCancel}>
            <UGE
                apiKey={apiKey || WEB_API_KEY}
                closeable
                defaultEditor={defaultEditor}
                enableStickers
                ref={ugeRef}
                source={editedUploadFile?.source || uploadFile.source}
                onClose={onCancel}
                onGAEvent={(event, options) => setGADataLayer({ event, options })}
            >
                <SaveButton gradient="indigo-purple" loading={isSaving} size="large" onClick={onDone}>
                    Save Changes
                </SaveButton>
            </UGE>
        </Modal>
    )
}

export default CreationUploadEditor
